<template>
  <b-sidebar
    id="sidebar-right"
    z-index="51001"
    title="LIFE News"
    right
    shadow
    :visible="prompt"
    backdrop
    no-header
    sidebar-class="sidebar-lg"
    header-class="header-dark"
    bg-variant="white"
    width="460px"
    @change="(val) => (prompt = val)"
    @hidden="clearForm"
  >
    <!-- @hidden="clearForm" -->
    <!--<template #footer="{ hide }">
      <div class="d-flex header-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">Footer</strong>
        <b-button size="sm" @click="hide">Close</b-button>
      </div>
    </template>-->

    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="
          textured-dark-background
          text-white
          d-flex
          justify-content-between
          align-items-center
          content-sidebar-header
          px-4
          py-3
        "
      >
        <!--  <b-button size="sm" variant="outline-success rounded-lg">
          {{ "Completed" }}
        </b-button> -->

        <h5 class="mb-0 text-white">LIFE News</h5>
        <div>
          <feather-icon
            class="cursor-pointer"
            icon="ChevronRightIcon"
            svgClasses="h-5 w-5"
            @click="hide"
          />
        </div>
      </div>

      <div class="p-4 textured-background" style="min-height: 100%">
        <Loading v-if="!news || news.length < 1" />
        <!-- News start -->

        <div v-else>
          <!--     <transition name="slide-fade">
            <news-article v-if="!showSpecificNews" :article="news[0]" />
          </transition> -->

          <!--    class="bordered-items" -->
          <div
            v-if="shouldFilterNews"
            @click.stop="shouldFilterNews = false"
            class="
              text-white
              cursor-pointer
              flex
              align-middle
              justify-start
              mb-3
            "
          >
            <feather-icon icon="ChevronLeftIcon" svgClasses="h-6 w-6" />
            Go back
          </div>
          <transition-group name="slide-fade" target="ul">
            <li
              v-for="article in filteredNews"
              :key="article.articleId"
              :class="{ 'cursor-pointer': !shouldFilterNews }"
              class="flex justify-between notification"
              @click.stop="filterNews(article.articleId)"
            >
              <news-article
                :article="article"
                :showDetails="shouldFilterNews"
              />
            </li>
          </transition-group>
        </div>
        <!-- News end -->
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { mapGetters } from "vuex";
import NewsArticle from "./News/NewsCard.vue";

export default {
  components: { NewsArticle },
  data() {
    return {
      showSpecificNews: false,
      shouldFilterNews: false,
      filterNewsId: "",
      prompt: false,
    };
  },

  computed: {
    ...mapGetters({
      news: "news/news",
    }),
    filteredNews() {
      return this.shouldFilterNews
        ? this.news.filter((article) => article.articleId === this.filterNewsId)
        : this.news;
    },
  },
  methods: {
    async show() {
      this.prompt = true;
      if (this.news || this.news.length < 1) {
        await this.$store.dispatch("news/getNews");
        console.log("Got news", this.news);
      }
      
    },
    filterNews(id) {
      if (!this.shouldFilterNews) {
        this.shouldFilterNews = true;
        this.filterNewsId = id;
      }
    },
    close() {},
    clearForm() {},
  },
  async mounted() {

  },
};
</script>


<style scoped lang="css" src="bootstrap/dist/css/bootstrap.min.css"></style>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.22.0/bootstrap-vue.min.css";

/* we will explain what these classes do next! */
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-460px);
  opacity: 0;
}
.textured-background {
  background-image: url("../../../../assets/images/texture.png") !important;
  background-repeat: repeat;
}
.textured-dark-background {
  background-image: url("../../../../assets/images/texture_dark.png") !important;
  background-repeat: repeat;
}

.header-dark {
  background-color: #f6f6f6;
}
.form-label {
  color: #5e5873;
  font-size: 0.857rem;
}
</style>
